
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        nav.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  var input = document.getElementById('review-photos');
  var error = document.getElementById('review-photo-error');
  if (input && error) {
    input.addEventListener('change', function () {
      if (input.files && input.files.length > 2) {
        error.style.display = 'block';
        input.value = '';
      } else {
        error.style.display = 'none';
      }
    });
  }

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel-track');
    var slides = carousel.querySelectorAll('[data-slide]');
    var dotsWrap = carousel.parentElement.querySelector('.carousel-dots');
    var dots = dotsWrap ? dotsWrap.querySelectorAll('.dot') : [];
    var prev = carousel.querySelector('.prev');
    var next = carousel.querySelector('.next');
    var index = 0;
    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (dot, i) { dot.classList.toggle('active', i === index); });
    }
    if (prev) prev.addEventListener('click', function () { index = (index - 1 + slides.length) % slides.length; render(); });
    if (next) next.addEventListener('click', function () { index = (index + 1) % slides.length; render(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { index = i; render(); }); });
    render();
  });
});
